import UserCourseServiceApi from '@/api/userCourseServiceApi.js';

const state = {
  activeCourses: {
    items: null,
    count: 0,
    loading: false
  },
  finishedCourses: {
    items: null,
    count: 0,
    loading: false
  },
  executingCourse: {
    course: {
      item: null,
      loading: false,
      tree: null
    },
    activeElement: {
      item: null,
      loading: false
    }
  }
};

const getters = {
  activeExecutionCourseState: state => {
    if (state.executingCourse.course.item) {
      return state.executingCourse.course.item.state;
    }

    return null;
  },
  activeExecutionCourseName: state => state.executingCourse.course.item && state.executingCourse.course.item.name,
  breadcrumbExecutingCourse: (_, getters) => getters.activeExecutionCourseName
};

const actions = {
  async getActiveCourses({ commit, rootState }, payload) {
    commit('CHANGE_ACTIVE_COURSES_LOADING', { loading: true });

    try {
      const api = new UserCourseServiceApi(rootState.account.token);
      const { data } = payload
        ? await api.getUserCourses(payload.search, payload.skip, payload.take)
        : await api.getUserCourses();

      commit('SAVE_ACTIVE_COURSES', {
        courses: data.result.items,
        totalCount: data.result.totalCount
      });
      commit('CHANGE_ACTIVE_COURSES_LOADING', { loading: false });
    } catch (e) {
      // TODO: handle
      console.error(e);
    }
  },
  async startCourseToExecute({ commit, rootState }, payload) {
    try {
      commit('CHANGE_EXECUTING_COURSE_LOADING', { loading: true });

      const { data } = await new UserCourseServiceApi(rootState.account.token).startCourseExecution(payload.courseId);

      commit('SAVE_EXECUTING_COURSE', {
        course: data.result
      });
      commit('CHANGE_EXECUTING_COURSE_LOADING', { loading: false });
      return true;
    } catch (e) {
      // TODO: handle
      console.error(e);
      return false;
    }
  },
  async getCourseToExecute({ commit, rootState }, payload) {
    try {
      commit('CHANGE_EXECUTING_COURSE_LOADING', { loading: true });

      const { data } = await new UserCourseServiceApi(rootState.account.token).getCourseExecution(payload.courseId);

      commit('SAVE_EXECUTING_COURSE', {
        course: data.result
      });
      commit('CHANGE_EXECUTING_COURSE_LOADING', { loading: false });
      return true;
    } catch (e) {
      // TODO: handle
      console.error(e);
      return false;
    }
  },
  async selectElementToExecute({ commit, rootState }, payload) {
    try {
      commit('CHANGE_EXECUTING_ELEMENT_LOADING', { loading: true });

      const response = await new UserCourseServiceApi(rootState.account.token).startElementExecution(payload.elementId);

      commit('SAVE_EXECUTING_ELEMENT', {
        element: response.data.result
      });
      commit('CHANGE_EXECUTING_ELEMENT_LOADING', { loading: false });
      return true;
    } catch (e) {
      // TODO: handle
      console.error(e);
      return false;
    }
  },
  clearElementToExecute({ commit }) {
    commit('CLEAR_EXECUTING_ELEMENT');
  },
  async elementExecutionOpened({ rootState, commit }, payload) {
    try {
      const { data } = await new UserCourseServiceApi(rootState.account.token).saveElementExecution(payload.element);

      commit('SAVE_EXECUTING_ELEMENT', {
        element: data.result
      });

      // await dispatch('getCourseToExecute', { courseId: payload.courseId });
    } catch (e) {
      // TODO: handle
      console.error(e);
    }
  },
  async finishElementExecution({ rootState, dispatch }, payload) {
    try {
      await new UserCourseServiceApi(rootState.account.token).finishElementExecution(payload.element);

      await dispatch('getCourseToExecute', { courseId: payload.courseId });
    } catch (e) {
      // TODO: handle
      console.error(e);
    }
  },
  async getFinishedCourses({ commit, rootState }, payload) {
    try {
      commit('CHANGE_FINISHED_COURSES_LOADING', { loading: true });

      const api = new UserCourseServiceApi(rootState.account.token);
      const { data } = payload
        ? await api.getFinishedUserCourses(payload.search, payload.skip, payload.take)
        : await api.getFinishedUserCourses();

      commit('SAVE_FINISHED_COURSES', {
        courses: data.result.items,
        totalCount: data.result.totalCount
      });
      commit('CHANGE_FINISHED_COURSES_LOADING', { loading: false });
    } catch (e) {
      // TODO: handle
      console.error(e);
    }
  }
};

const mutations = {
  SAVE_ACTIVE_COURSES(state, payload) {
    state.activeCourses = {
      ...state.activeCourses,
      items: payload.courses,
      count: payload.totalCount
    };
  },
  CHANGE_ACTIVE_COURSES_LOADING(state, payload) {
    state.activeCourses = {
      ...state.activeCourses,
      loading: payload.loading
    };
  },
  SAVE_EXECUTING_COURSE(state, payload) {
    state.executingCourse = {
      ...state.executingCourse,
      course: {
        ...state.executingCourse.course,
        tree: createTree(payload.course.moduleExecutions),
        item: payload.course
      }
    };
  },
  CHANGE_EXECUTING_COURSE_LOADING(state, payload) {
    state.executingCourse = {
      ...state.executingCourse,
      course: {
        ...state.executingCourse.course,
        loading: payload.loading
      }
    };
  },
  SAVE_EXECUTING_ELEMENT(state, payload) {
    state.executingCourse = {
      ...state.executingCourse,
      activeElement: {
        ...state.executingCourse.activeElement,
        item: payload.element
      }
    };
  },
  CLEAR_EXECUTING_ELEMENT(state) {
    state.executingCourse = {
      ...state.executingCourse,
      activeElement: {
        ...state.executingCourse.activeElement,
        item: null
      }
    };
  },
  CHANGE_EXECUTING_ELEMENT_LOADING(state, payload) {
    state.executingCourse = {
      ...state.executingCourse,
      activeElement: {
        ...state.executingCourse.activeElement,
        loading: payload.loading
      }
    };
  },
  SAVE_FINISHED_COURSES(state, payload) {
    state.finishedCourses = {
      ...state.finishedCourses,
      items: payload.courses,
      count: payload.totalCount
    };
  },
  CHANGE_FINISHED_COURSES_LOADING(state, payload) {
    state.finishedCourses = {
      ...state.finishedCourses,
      loading: payload.loading
    };
  }
};

function createTree(moduleExecutions) {
  return moduleExecutions.map(element => {
    const newElement = {
      ...element,
      icon: mapIcon(element.elementType)
    };

    if (!element.isExecuteable) {
      newElement.children = createTree(mergeElements(element.elementExecutions, element.moduleExecutions));
      newElement.active = true;
      newElement.treeColor = mapModuleColor(element.state);
      newElement.treeClass = mapModuleClass(element.state);
    } else {
      newElement.treeColor = mapElementColor(element.state);
      newElement.treeClass = mapElementClass(element.state);
    }

    return newElement;
  });
}

function mapIcon(type) {
  if (!type) {
    return 'mdi-folder';
  }

  switch (type) {
    case 1: // lesson
      return 'mdi-school';
    case 2: // video
      return 'mdi-video';
    case 3: // file
      return 'mdi-file-multiple';
    case 4: // meeting
      return 'mdi-account-multiple';
    default:
      throw 'Unsupported element type';
  }
}

function mapModuleColor(state) {
  switch (state) {
    case 1: // Incomplete
      return 'orange';
    case 2: // Completed
      return 'green';
    default:
      // NotAttempted
      return undefined;
  }
}

function mapModuleClass(state) {
  switch (state) {
    case 1: // Incomplete
      return 'orange--text';
    case 2: // Completed
      return 'green--text';
    default:
      // NotAttempted
      return undefined;
  }
}

function mapElementColor(state) {
  switch (state) {
    case 1: // Browsed
      return 'green';
    case 2: // Incomplete
      return 'orange';
    case 3: // Completed
      return 'green';
    case 4: // Failed
      return 'red';
    case 5: // Passed
      return 'green';
    default:
      // NotAttempted
      return undefined;
  }
}

function mapElementClass(state) {
  switch (state) {
    case 1: // Browsed
      return 'green--text';
    case 2: // Incomplete
      return 'orange--text';
    case 3: // Completed
      return 'green--text';
    case 4: // Failed
      return 'red--text';
    case 5: // Passed
      return 'green--text';
    default:
      // NotAttempted
      return undefined;
  }
}

function mergeElements(elementExecutions, moduleExecutions) {
  const merged = [...(elementExecutions || []), ...(moduleExecutions || [])];
  return merged.sort((elementA, elementB) => elementA.order - elementB.order);
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
